<template>
  <div class="h-100 d-flex justify-content-center align-items-center">
    <b-col xs="10" md="6" lg="4" xl="3">
      <div class="pt-5 pb-5 text-center">
        <img
          src="@/assets/img/logo/logo.jpg"
          alt="Boxx Barber Shop logo"
          height="200"
        />
        <h2 class="text-center mt-3">Booking System</h2>
      </div>
      <b-form @submit.prevent="submit">
        <b-form-group label="Email Address">
          <b-form-input type="text" placeholder="Email" v-model="model.email" />
        </b-form-group>
        <b-form-group
          label="Password"
          description="Please contact Advanced Cloud Services Support if you have forgotten your password."
        >
          <b-form-input
            type="password"
            placeholder="Password"
            v-model="model.password"
          />
        </b-form-group>
        <br />
        <b-button variant="primary" type="submit" block>
          <b-spinner
            v-if="submitting"
            variant="light"
            style="height: 20px; width: 20px;"
            label="Submitting login credentials"
          ></b-spinner>
          <span v-else>
            Login
          </span>
        </b-button>
      </b-form>
    </b-col>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      model: { email: null, password: null },
      submitting: false
    };
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    async submit() {
      this.submitting = true;

      try {
        await this.login(this.model);
        this.$router.push('/admin/stores/ifsc');
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped></style>
